import {XStack, YStack} from "@chayka/ui";
import {useAuth} from "@/hooks/useAuth";
import {InformationCircleOutline} from "@chayka/icons";
import clsx from "clsx";
import {useState} from "react";
import {FinesAndBalanceBottomSheet} from "../FinesAndBalanceBottomSheet";

export const ProfileCard = () => {
  const {user} = useAuth();
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);

  if (!user) {
    return null;
  }

  return (
    <YStack className="items-center gap-4">
      <div className="text-lg font-semibold text-center">
        {user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.displayName}
      </div>
      <XStack className="justify-start items-center self-start gap-4">
        <YStack>
          <div className="text-inactive-text text-sm">Баланс</div>
          <div className="font-bold">{user.balance} ₽</div>
        </YStack>
        <YStack>
          <div className="text-inactive-text text-sm">Штрафы</div>
          <div className={clsx("font-bold", user.fines > 0 && "text-error")}>{user.fines} ₽</div>
        </YStack>
      </XStack>
      <div
        className="text-inactive-text text-sm self-start align-middle"
        onClick={() => setIsBottomSheetOpen(true)}
      >
        <InformationCircleOutline size={15} className="inline-block mr-1 -mt-1" />
        Что такое штрафы и баланс?
      </div>
      <FinesAndBalanceBottomSheet
        isOpen={isBottomSheetOpen}
        onClose={() => setIsBottomSheetOpen(false)}
      />
    </YStack>
  );
};
